<template>
    <div class="Search_box">
        <p class="tilte">{{$t('Homedata.tilte2')}} 
            <!-- <span class="iconfont icon-youjiantou iconTu"></span>-->
        </p>
        <div class="hall">
            <div class="flex-one" v-for="(item,index) in Geshoudata" :key="index" @click="SongDianji(item)">
                <div class="cover">
                    <div class="cover-Mask">
                        <img src="../../assets/jianshi.png" alt="">
                    </div>
                    <img class="bei-tupian" :src="item.image" alt="">
                </div>
                <p class="cover-bottom-text">{{item.name}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'Search',
    data() {
        return {
            Geshoudata:[]//歌手
        }
    },
    mounted(){
        this.GeshouAjax();
    },
    methods: {
        //请求歌手
        GeshouAjax(){
            axios.post('api/index/singer')
            .then(response => {
                // 处理请求成功的响应
                console.log(response.data);
                this.Geshoudata = response.data.data;
            })
            .catch(error => {
                // 处理请求失败的错误
                console.error(error);
            });
        },
        SongDianji(item){
            this.$router.push(`vocalist/${item.id}`)
        }
    }
}
</script>

<style scoped lang="scss">
.Search_box {
    width: 83%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding-top: 10px;
    // background-color: aqua;
    margin: 0 auto;

    .hall {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
        // background-color: aqua;
        gap:13px;
        margin-top: 20px;
        // 多个内容
        .flex-one {
            width: 190px;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 15px;
            //封面图
            .cover {
                width: 100%;
                height: 190px;
                display: flex;
                align-items: center;
                justify-content: center;
                border: solid 1px var(--them-background);
                overflow: hidden;
                border-radius: 50%;
                cursor: pointer;
                position: relative;

                .cover-Mask {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: rgba(0, 0, 0, 0.3);
                    z-index: 1;
                    transition: 0.3s;
                    opacity: 0;

                    img {
                        transition: 0.2s;
                        width: 12%;
                        height: 12%;
                    }
                }

                .bei-tupian {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    z-index: 0;
                }
            }

            .cover:hover .cover-Mask {
                transition: 0.3s;
                opacity: 1;

                img {
                    transition: 0.2s;
                    width: 16%;
                    height: 16%;
                }
            }

            // 封面下面的文字标题
            .cover-bottom-text {
                font-size: var(--nav-text-fsize16);
                font-family: YuanTi;
                // font-weight: bold;
                margin-top: 10px;
                color: var(--them-L-nav-color);
            }

            .cover-bottom-textTwo {
                width: 100%;
                font-size: var(--nav-text-fsize);
                font-family: YuanTi;
                font-weight: bold;
                margin-top: 5px;
                color: var(--them-song-text-color);
            }
        }
    }
}

.tilte {
    font-size: 20px;
    font-family: YuanTi;
    font-weight: bold;
    // font-style: italic;
    cursor: pointer;
    color: var(--them-color);

    .iconTu {
        font-size: 12px;
        font-weight: 100;
        font-weight: bold;
        color: var(--them-L-nav-color);
    }
}
</style>